import { getDatabase, ref, set, remove, update, get, onValue, off, push, query, orderByChild, startAt, endAt } from "firebase/database";
import db from './index';
import { Constants, getCompactDate } from "../_helpers";
import { accountService } from "../_services";

export function getUserInfo(uid) {
  const dbRef = ref(db, "users/" + uid);
  return get(dbRef)
    .then((snapshot) => {
      if (snapshot.exists()) {
        return snapshot.val();
      } else {
        return null;  //Customer
      }
    });
}

export function updateUserInfo(uid, curFields, newFields) {
 
  const updates = {};

  const newDisplayName = newFields.lastName ? newFields.firstName + ' ' + newFields.lastName : newFields.firstName;
  if (newDisplayName && curFields.displayName !== newDisplayName) {
    updates["users/" + uid + "/displayName"] = newDisplayName;
    if (curFields.storeId){
      curFields.storeId.split(",").forEach(storeId => {
        updates["stores/" + storeId + "/users/" + uid + "/displayName"] = newDisplayName;
      });  
    }
  }

  if (newFields.title && curFields.title !== newFields.title) {
    updates["users/" + uid + "/title"] = newFields.title;
  }

  if (newFields.address && curFields.address !== newFields.address) {
    updates["users/" + uid + "/address"] = newFields.address;
  }

  return update(ref(db), updates);
}
